export default __webpack_public_path__ + "static/media/cubs-marshmallow.3c17c125.jpg";